<template>
    <div>
        <div>
            <div class="-space-y-px rounded-md"
                 :class="{
                   'bg-iron-50': !isOwner,
                   'bg-white': isOwner,
                }"
            >
                <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-iron-200" -->
                <div
                    v-for="(workflow, key) in workflows"
                    :key="workflow.id"
                    class="relative flex border p-2"
                    :class="{
                        'rounded-tl-md rounded-tr-md': key === 0,
                        'rounded-bl-md rounded-br-md':
                            workflows.length === key + 1,
                        'cursor-pointer hover:bg-iron-50 focus:outline-none': isOwner,
                        'cursor-not-allowed': !isOwner,
                    }"
                    @click="
                        isWorkflowAlreadyAssigned(
                            workflow.id,
                            eventType.workflows,
                        )
                            ? detachWorkflow(workflow.id)
                            : assignWorkflow(workflow.id)
                    "
                >
                    <!-- <div class="flex items-center justify-center">
                                                        <div class="border border-iron-300 h-5 w-5">



                                                            <CheckIcon v-if="isWorkflowAlreadyAssigned(workflow.id, eventType.workflows)"/>
                                                        </div>
                                                    </div> -->

                    <input
                        id="comments"
                        :checked="
                            isWorkflowAlreadyAssigned(
                                workflow.id,
                                eventType.workflows,
                            )
                        "
                        aria-describedby="comments-description"
                        name="comments"
                        type="checkbox"
                        :disabled="!isOwner"
                        class="mt-1 h-5 w-5 rounded border-iron-300 text-z-orange-600 focus:ring-z-orange-600"
                        :class="{ 'cursor-not-allowed bg-iron-50': !isOwner }"
                    />
                    <span class="ml-5 flex flex-col">
                        <!-- Checked: "text-indigo-900", Not Checked: "text-iron-900" -->
                        <span
                            id="privacy-setting-0-label"
                            class="block text-sm font-medium"
                            >{{ workflow.name }}</span
                        >
                        <!-- Checked: "text-indigo-700", Not Checked: "text-iron-500" -->

                        <span
                            v-if="
                                workflow.trigger !==
                                'reservation_will_happen_in'
                            "
                            id="privacy-setting-0-description"
                            class="block text-sm"
                        >
                            {{
                                $t(
                                    "workflows.trigger_send_to_" +
                                        workflow.target +
                                        "_when_" +
                                        workflow.trigger,
                                )
                            }}
                        </span>
                        <span
                            v-else
                            id="privacy-setting-0-description"
                            class="block text-sm"
                        >
                            {{
                                $t(
                                    "workflows.trigger_send_to_" +
                                        workflow.target +
                                        "_event_happen_in",
                                )
                            }}
                            {{
                                convertSeconds(
                                    JSON.parse(workflow.data).timeBefore,
                                )
                            }}.
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {router, usePage} from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import type { EventType } from "../types/EventType";
import route from "ziggy-js";

const { t } = useI18n();

const props = defineProps<{
    eventType: EventType;
    workflows: any[];
    isOwner: boolean;
    isPersonalInTeam: boolean;
}>();

type SharedData = {
    userId: number;
};

const page = usePage<SharedData>();

const detachWorkflow = function (workflowId: number) {
    router.post(
        route('app.event-types.workflows.detach', { eventType: props.eventType.id }),
        {
            workflowId: workflowId,
            isPersonalInTeam: props.isPersonalInTeam,
        },
        {
            onFinish: () => {},
        },
    );
};

const assignWorkflow = function (workflowId: number) {
    if (!props.isOwner) {
        return;
    }

    router.post(
        route('app.event-types.workflows.assign', { eventType: props.eventType.id }),
        {
            workflowId: workflowId,
            isPersonalInTeam: props.isPersonalInTeam,
        },
        {
            onFinish: () => {},
        },
    );
};

const convertSeconds = function (seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const result = [];

    if (days > 0) {
        result.push(`${days} ${t("workflows.days", days)}`);
    }

    const remainingHours = hours % 24;
    if (remainingHours > 0) {
        result.push(
            `${remainingHours} ${t("workflows.hours", remainingHours)}`,
        );
    }

    const remainingMinutes = minutes % 60;
    if (remainingMinutes > 0) {
        result.push(
            `${remainingMinutes} ${t("workflows.minutes", remainingMinutes)}`,
        );
    }

    const remainingSeconds = seconds % 60;
    if (remainingSeconds > 0) {
        result.push(
            `${remainingSeconds} ${t("workflows.seconds", remainingSeconds)}`,
        );
    }

    return result.join(", ");
};

const isWorkflowAlreadyAssigned = (id: number, assignedWorkflows: any) => {
    for (let i = 0; i < assignedWorkflows.length; i++) {
        if (
            props.isPersonalInTeam &&
            assignedWorkflows[i].id === id &&
            assignedWorkflows[i].pivot.user_id === page.props.userId
        ) {
            return true;
        }

        if (!props.isPersonalInTeam && assignedWorkflows[i].id === id && assignedWorkflows[i].pivot.user_id === null) {
            return true;
        }
    }
    return false;
};
</script>

<style></style>
